// src/api.js

/**
 * Função utilitária para buscar marcas
 * @returns {Promise<Array>} - array de marcas ou vazio em caso de erro
 */
export const fetchBrands = async () => {
  try {
    const response = await fetch('https://advancelighting.pt/listBrands2.php');

    if (!response.ok) {
      throw new Error(`Erro na requisição: ${response.status}`);
    }

    const data = await response.json();
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error('Erro ao carregar marcas:', error);
    return [];
  }
};

/**
 * Função utilitária para buscar produtos recomendados pelo ID
 * @param {Array<number>} ids - array de IDs de produtos
 * @returns {Promise<Array>} - array de produtos ou vazio
 */
export const fetchRecommendedProducts = async (ids = []) => {
  if (!ids.length) return [];

  const productIds = ids.join(',');
  try {
    const response = await fetch(`https://advancelighting.pt/RecommendedProducts.php?ids=${productIds}`);

    if (!response.ok) {
      throw new Error(`Erro na requisição: ${response.status}`);
    }

    const data = await response.json();
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error('Erro ao carregar produtos recomendados:', error);
    return [];
  }
};